module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "orna-top"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }), _c('img', {
    attrs: {
      "alt": "Zipes",
      "src": "images/ornament2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "content-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "orna-bottom"
  }, [_c('img', {
    attrs: {
      "alt": "Zipes",
      "src": "images/ornament3.png"
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "contents"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/list.htm#List"
    }
  }, [_c('i', [_vm._v("List of Figures")])])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/list.htm#List"
    }
  }, [_vm._v("ix")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/pref.htm#Pref"
    }
  }, [_c('i', [_vm._v("Preface")])])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pref.htm#Pref"
    }
  }, [_vm._v("xi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#Notes"
    }
  }, [_c('i', [_vm._v("Notes and Acknowledgments")])])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#Notes"
    }
  }, [_vm._v("xxiii")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/intro.htm#Intro"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('table', {
    staticClass: "contents"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/intro.htm#Intro"
    }
  }, [_vm._v("The Sorcerer’s Apprentice, Harry Potter, and Why Magic Matters")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/intro.htm#Intro"
    }
  }, [_vm._v("1")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1.htm#Part1"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PART I. THE HUMILIATED APPRENTICE TALES")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#pt1-Chap1"
    }
  }, [_c('i', [_vm._v("Early Tales")])])]), _vm._v(" "), _c('table', {
    staticClass: "contents"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#H1"
    }
  }, [_vm._v("Lucian of Samosata, “Eucrates and Pancrates” (ca. 170 CE)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#H1"
    }
  }, [_vm._v("85")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#H2"
    }
  }, [_vm._v("François Pétis de la Croix, “The Story of the Brahmin Padmanaba and the Young Hassan” (1707)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#H2"
    }
  }, [_vm._v("88")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#H3"
    }
  }, [_vm._v("Johann Wolfgang von Goethe, “The Pupil in Magic” (1798)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#H3"
    }
  }, [_vm._v("97")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#pt1-Chap2"
    }
  }, [_c('i', [_vm._v("Nineteenth-Century Tales")])])]), _vm._v(" "), _c('table', {
    staticClass: "contents"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H4"
    }
  }, [_vm._v("Robert Southey, “Cornelius Agrippa’s Bloody Book” (1801)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H4"
    }
  }, [_vm._v("101")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H5"
    }
  }, [_vm._v("Sir Walter Scott, “The Last Exorciser” (1838)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H5"
    }
  }, [_vm._v("103")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H6"
    }
  }, [_vm._v("John Naaké, “The Book of Magic” (1874)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H6"
    }
  }, [_vm._v("103")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H7"
    }
  }, [_vm._v("Alfred Cooper Fryer, “The Master and His Pupil; or, The Magic Book” (1884)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H7"
    }
  }, [_vm._v("105")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H8"
    }
  }, [_vm._v("Sheykh-Zāda, “The Lady’s Fifth Story” (1886)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H8"
    }
  }, [_vm._v("110")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H9"
    }
  }, [_vm._v("Edith Hodgetts, “The Blacksmith and the Devil” (1890)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#H9"
    }
  }, [_vm._v("112")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#pt1-Chap3"
    }
  }, [_c('i', [_vm._v("Twentieth-Century Tales")])])]), _vm._v(" "), _c('table', {
    staticClass: "contents"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#H10"
    }
  }, [_vm._v("Henry Thomas Francis, “The Rash Magician” (1916)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#H10"
    }
  }, [_vm._v("117")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#H11"
    }
  }, [_vm._v("Richard Rostron, “The Sorcerer’s Apprentice” (1941)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#H11"
    }
  }, [_vm._v("119")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#H12"
    }
  }, [_vm._v("Richard Dorson, “The Mojo” (1956)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#H12"
    }
  }, [_vm._v("123")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#H13"
    }
  }, [_vm._v("Harold Courlander, “The Do-All Ax” (1957)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#H13"
    }
  }, [_vm._v("124")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/pt2.htm#Part2"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PART II. THE REBELLIOUS APPRENTICE TALES")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#pt2-Chap1"
    }
  }, [_c('i', [_vm._v("Early Tales")])])]), _vm._v(" "), _c('table', {
    staticClass: "contents"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H14"
    }
  }, [_vm._v("Ovid, “Erysichthon and Mestra” (8 CE)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H14"
    }
  }, [_vm._v("129")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H15"
    }
  }, [_vm._v("Rachel Harriette Busk, “The Saga of the Well-and-Wise-Walking Khan” (ca. 3"), _c('sup', [_vm._v("rd")]), _vm._v(" Century to 11"), _c('sup', [_vm._v("th")]), _vm._v(" Century)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H15"
    }
  }, [_vm._v("136")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H16"
    }
  }, [_vm._v("Somadeva, “Bhavašarman and the Two Witches” (ca. 1070)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H16"
    }
  }, [_vm._v("140")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H17"
    }
  }, [_vm._v("Farīd al-Dīn "), _c('span', {
    staticClass: "times"
  }, [_vm._v("ʿ")]), _vm._v("Attār, “The Magician’s Apprentice” (ca. 1220)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H17"
    }
  }, [_vm._v("142")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H18"
    }
  }, [_vm._v("Giovan Francesco Straparola, “Maestro Lattantio and His Apprentice Dionigi” (1553)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H18"
    }
  }, [_vm._v("144")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H19"
    }
  }, [_vm._v("Sangendhi Mahalingam Natesa Sastri, “The Deceiver Shall Be Deceived” (ca. 1770)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#H19"
    }
  }, [_vm._v("151")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#pt2-Chap2"
    }
  }, [_c('i', [_vm._v("Nineteenth-Century Tales")])])]), _vm._v(" "), _c('table', {
    staticClass: "contents"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H20"
    }
  }, [_vm._v("Jacob and Wilhelm Grimm, “The Nimble Thief and His Master” (1819)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H20"
    }
  }, [_vm._v("163")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H21"
    }
  }, [_vm._v("Kazimierz Wladyslaw Woycicki, “The Sorcerer and His Apprentice” (1839)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H21"
    }
  }, [_vm._v("166")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H22"
    }
  }, [_vm._v("Arthur and Albert Schott, “The Devil and His Pupil” (1845)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H22"
    }
  }, [_vm._v("169")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H23"
    }
  }, [_vm._v("Ludwig Bechstein, “The Magic Combat” (1857)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H23"
    }
  }, [_vm._v("174")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H24"
    }
  }, [_vm._v("Johann Georg von Hahn, “The Teacher and His Pupil” (1864)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H24"
    }
  }, [_vm._v("178")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H25"
    }
  }, [_vm._v("Giuseppe Pitrè, “The Tuft of Wild Beet” (1875)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H25"
    }
  }, [_vm._v("184")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H26"
    }
  }, [_vm._v("Domenico Comparetti, “Oh, Relief!” (1875)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H26"
    }
  }, [_vm._v("190")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H27"
    }
  }, [_vm._v("François-Marie Luzel, “The Magician and His Servant” (1885)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H27"
    }
  }, [_vm._v("193")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H28"
    }
  }, [_vm._v("George Webbe Dasent, “Farmer Weathersky” (1888)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H28"
    }
  }, [_vm._v("202")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H29"
    }
  }, [_vm._v("Jerome Curtin, “The Fisherman’s Son and the Gruagach of Tricks” (1890)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H29"
    }
  }, [_vm._v("209")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H30"
    }
  }, [_vm._v("Edith Hodgetts, “The Wonderful Trade” (1890)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H30"
    }
  }, [_vm._v("218")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H31"
    }
  }, [_vm._v("Charles Swynnerton, “The Story of Ali the Merchant and the Brahmin” (1892)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#H31"
    }
  }, [_vm._v("227")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#pt2-Chap3"
    }
  }, [_c('i', [_vm._v("Twentieth-Century Tales")])])]), _vm._v(" "), _c('table', {
    staticClass: "contents"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H32"
    }
  }, [_vm._v("Leo Wiener, “The Tale of the Sorcerer” (1902)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H32"
    }
  }, [_vm._v("243")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H33"
    }
  }, [_vm._v("Joseph Charles Mardrus, “The Twelfth Captain’s Tale” (ca. 1904)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H33"
    }
  }, [_vm._v("247")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H34"
    }
  }, [_vm._v("Fletcher Gardner, “The Battle of the Enchanters” (1907)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H34"
    }
  }, [_vm._v("253")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H35"
    }
  }, [_vm._v("Peter Buchan, “The Black King of Morocco” (1908)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H35"
    }
  }, [_vm._v("254")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H36"
    }
  }, [_vm._v("Cecil Henry Bompas, “The Boy Who Learnt Magic” (1909)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H36"
    }
  }, [_vm._v("257")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H37"
    }
  }, [_vm._v("Edith Nesbit, “The Magician’s Heart” (1912)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H37"
    }
  }, [_vm._v("260")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H38"
    }
  }, [_vm._v("Claude-Marius Barbeau, “The Two Magicians” (1916)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H38"
    }
  }, [_vm._v("272")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H39"
    }
  }, [_vm._v("Hermann Hesse, “The Forest Dweller” (1917)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H39"
    }
  }, [_vm._v("274")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H40"
    }
  }, [_vm._v("Heywood Broun, “Red Magic” (1921)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H40"
    }
  }, [_vm._v("281")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H41"
    }
  }, [_vm._v("Dean Fansler, “The Mysterious Book” (1921)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H41"
    }
  }, [_vm._v("286")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H42"
    }
  }, [_vm._v("Elsie Clews Parsons, “The Battle of the Enchanters” (1923)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H42"
    }
  }, [_vm._v("289")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H43"
    }
  }, [_vm._v("Romuald Pramberger, “The Sorcerer’s Apprentice” (1926)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H43"
    }
  }, [_vm._v("293")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H44"
    }
  }, [_vm._v("Seumas MacManus, “The Mistress of Magic” (1926)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H44"
    }
  }, [_vm._v("296")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H45"
    }
  }, [_vm._v("Joseph Médard Carrière, “The Two Magicians” (1937)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H45"
    }
  }, [_vm._v("306")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H46"
    }
  }, [_vm._v("John Mason Brewer, “The High Sheriff and His Servant” (1958)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H46"
    }
  }, [_vm._v("311")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H47"
    }
  }, [_vm._v("Corinne Saucier, “The Man and His Son” (1962)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H47"
    }
  }, [_vm._v("312")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H48"
    }
  }, [_vm._v("A. K. Ramanujan, “The Magician and His Disciple” (1997)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#H48"
    }
  }, [_vm._v("313")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt-"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#Part3"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PART III. KRABAT TALES")])])]), _vm._v(" "), _c('table', {
    staticClass: "contents"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H49"
    }
  }, [_vm._v("Joachim Leopold Haupt, “About an Evil Man in Groß-Särchen” (1837)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H49"
    }
  }, [_vm._v("323")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H50"
    }
  }, [_vm._v("Michael Hornig, “Krabat: A Legend from Folklore” (1858)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H50"
    }
  }, [_vm._v("324")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H51"
    }
  }, [_vm._v("Georg Gustav Kubasch, “Krabat” (1865)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H51"
    }
  }, [_vm._v("326")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H52"
    }
  }, [_vm._v("Edmund Veckenstedt, “The Sorcerer’s Apprentice, I” (1880; Recorded by Hendrich Jordan)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H52"
    }
  }, [_vm._v("329")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H53"
    }
  }, [_vm._v("Edmund Veckenstedt, “The Sorcerer’s Apprentice, II” (1880; Recorded by Alexander von Rabenau)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H53"
    }
  }, [_vm._v("331")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H54"
    }
  }, [_vm._v("Johann Goltsch, “The Story about Krabat” (1885)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H54"
    }
  }, [_vm._v("333")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H55"
    }
  }, [_vm._v("Georg Pilk, “The Wendish Faust Legend” (1900)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H55"
    }
  }, [_vm._v("334")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-h1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H56"
    }
  }, [_vm._v("Jerzy Slizinski, “Krabat” (1959)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#H56"
    }
  }, [_vm._v("344")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-bm-"
  }, [_c('a', {
    attrs: {
      "href": "#/biographies.htm#Biographies"
    }
  }, [_c('i', [_vm._v("Biographies of Authors, Editors, Collectors, and Translators")])])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page-"
  }, [_c('a', {
    attrs: {
      "href": "#/biographies.htm#Biographies"
    }
  }, [_vm._v("349")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-bm"
  }, [_c('a', {
    attrs: {
      "href": "#/filmography.htm#Filmography"
    }
  }, [_c('i', [_vm._v("Filmography")])])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/filmography.htm#Filmography"
    }
  }, [_vm._v("365")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-bm"
  }, [_c('a', {
    attrs: {
      "href": "#/bibliography.htm#Bibliography"
    }
  }, [_c('i', [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/bibliography.htm#Bibliography"
    }
  }, [_vm._v("369")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-bm"
  }, [_c('a', {
    attrs: {
      "href": "#/chronological.htm#Chronological"
    }
  }, [_c('i', [_vm._v("Selected and Chronological List of Sorcerer’s Apprentice Tales")])])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/chronological.htm#Chronological"
    }
  }, [_vm._v("387")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "contents-bm"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#Index"
    }
  }, [_c('i', [_vm._v("Index")])])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule-page"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#Index"
    }
  }, [_vm._v("397")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0